import { Navigate } from 'react-router-dom';
import { IS_DEV_TOOLS_ENABLED } from '../utils/devTools';

/**
 * Route guard for developer-only surfaces (`/settings/development/seeding`).
 *
 * The seeding page shipped in the production bundle guarded by ROLE ONLY, and
 * its buttons call `POST`/`DELETE api/dev/seed/company/{id}` — generate and WIPE
 * a tenant's data. An Operator account on prod could reach it by typing the URL.
 * Role is the wrong axis for that page: the page should not exist off dev at all.
 *
 * Nested INSIDE the existing `RoleProtectedRoute`, not instead of it — the two
 * are independent conditions (Operator AND a dev environment) and neither
 * subsumes the other.
 *
 * The bounce is silent and immediate: there is no honest message to show a user
 * about a page that does not exist in their build, and inventing one would add
 * translation keys for a string nobody in production should ever read.
 */

interface DevToolsRouteProps {
  children: React.ReactElement;
}

export const DevToolsRoute = ({ children }: DevToolsRouteProps) => {
  if (!IS_DEV_TOOLS_ENABLED) return <Navigate to="/" replace />;
  return children;
};

export default DevToolsRoute;
